import { render, staticRenderFns } from "./PlayerLobby.vue?vue&type=template&id=474099ac&scoped=true&"
import script from "./PlayerLobby.vue?vue&type=script&lang=js&"
export * from "./PlayerLobby.vue?vue&type=script&lang=js&"
import style0 from "./PlayerLobby.vue?vue&type=style&index=0&id=474099ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474099ac",
  null
  
)

export default component.exports